var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(230),expression:"230"}],staticClass:"left-nav__container"},[_c('leftNav',_vm._g(_vm._b({staticStyle:{"width":"100%"}},'leftNav',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }